import React, { Component } from 'react'
import Form from './Form'
import {Switch, Route, NavLink} from 'react-router-dom'
import Finder from './Finder'

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faDownload} from '@fortawesome/free-solid-svg-icons'

const CtrlF = () => {
    return (
        <div className = "CtrlF">
            <div>
                Here's a PDF compilation of past Local/USNCO multiple choice exams:
            </div>

            <div className="center">
                <a className="download" href = {process.env.PUBLIC_URL+"/MC Compilation.pdf"} download>
                <FontAwesomeIcon icon={faDownload}/>MC Compilation</a>
            </div>

            <div>
                The year and test can be determined from the text in each page's footer.
            </div>
            <div>
                Happy Ctrl+F hunting!
            </div>
        </div>
    );
}

const SearchBar = () => (
    <div className = "homebuttons">
        <div>
        <NavLink exact activeClassName="hide" to='/'  className = "navbutton width250">Home</NavLink>
        </div>

        <div>
        <NavLink exact activeClassName="hide" to='/search/Ctrl+F'  className = "navbutton width250">Ctrl+F</NavLink>
        </div>

        <div>
        <NavLink exact activeClassName="hide" to='/search'  className = "navbutton width250">Search</NavLink>
        </div>

        <div>
        <NavLink exact activeClassName="hide" to='/search/Topics'  className = "navbutton width250">Topic Selection</NavLink>
        </div>
    </div>
)

export default class Search extends Component {
    handleSubmit = (topics,exclude) => {
        this.props.changeTopic(topics,exclude);
    }
    


    render() {
        return (
            <div className = "home">
                <div className = "header home">
                        <Switch>
                        <Route exact path="/search" render={() => <div>Search</div>}></Route>
                        <Route exact path="/search/Topics" render={() => <div>Topic Selection</div>}></Route>
                        <Route exact path="/search/Ctrl+F" render={() => <div>Ctrl+F</div>}></Route>
                        </Switch>
                </div>

                <div className='container'>
                    <div className = "lightblue">
                        <SearchBar />
                    </div>
                        <Switch>
                        <Route exact path="/search/Topics" render={(props) => <Form {...props} handleSubmit={this.handleSubmit}/>}></Route>
                        <Route exact path="/search/Ctrl+F" render={() => <CtrlF/>}></Route>
                        <Route exact path="/search" render={(props) => <Finder {...props} handleSubmit={this.getQuestion}/>}></Route>
                        </Switch>
                </div>
            </div>
        )
    }
}
